import { combineReducers } from "redux";

const AUTH_LOGIN = "AUTH_LOGIN";
const AUTH_LOGOUT = "AUTH_LOGOUT";

const defaultAuth = null;

export function loginAuth(auth) {
    return {
        type: AUTH_LOGIN,
        auth,
    };
}

export function logoutAuth() {
    return {
        type: AUTH_LOGOUT,
        defaultAuth,
    };
}

function auth(state = defaultAuth, action) {
    switch (action.type) {
        case AUTH_LOGIN:
            return {
                auth_data: action.auth.auth_data,
                access_token: action.auth.access_token,
            };

        case AUTH_LOGOUT:
            return defaultAuth;

        default:
            return state;
    }
}

const AuthStore = combineReducers({
    auth,
});

export default AuthStore;
